import React, { useState, useEffect } from 'react';
import { CourseCard } from './CourseCard';
import { courses as mockCourses } from '../mock';
import { GraduationCap, Loader2, AlertCircle } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL}/courses`);
        
        if (response.data && response.data.length > 0) {
          setCourses(response.data);
          setError(null);
        } else {
          setError('Keine Kurse verfügbar.');
        }
      } catch (err) {
        console.error('Error fetching courses:', err);
        setError('Fehler beim Laden der Kurse. Bitte versuchen Sie es später erneut.');
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  return (
    <section id="courses" className="py-24 bg-gradient-to-b from-white to-[#FFFBF0]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-full mb-6 shadow-lg">
            <GraduationCap className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-[#D4AF37] to-[#FFD700] bg-clip-text text-transparent">
              Termine
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Von Grundlagen bis zur Meisterschaft – wähle den passenden Kurs für Deine finanzielle Reise
          </p>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="flex justify-center items-center py-12">
            <Loader2 className="w-8 h-8 text-[#D4AF37] animate-spin" />
            <span className="ml-3 text-gray-600">Kurse werden geladen...</span>
          </div>
        )}

        {/* Error State (still shows courses from fallback) */}
        {error && !loading && (
          <div className="flex justify-center items-center py-4 mb-8">
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex items-center space-x-3">
              <AlertCircle className="w-5 h-5 text-yellow-600" />
              <span className="text-yellow-800 text-sm">{error}</span>
            </div>
          </div>
        )}

        {/* Course Grid */}
        {!loading && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {courses.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        )}

        {/* Bottom CTA */}
        {!loading && (
          <div className="mt-16 text-center bg-gradient-to-r from-[#D4AF37]/10 via-[#FFD700]/10 to-[#D4AF37]/10 rounded-2xl p-12 border border-[#D4AF37]/20">
            <h3 className="text-3xl font-bold mb-4 text-gray-900">
              Bist Du bereit für ein finanziell erfolgreicheres Leben?
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Wähle Deinen Kurs und starte heute Deine Reise zur finanziellen Intelligenz
            </p>
          </div>
        )}
      </div>
    </section>
  );
};
